import React, { Suspense } from "react";
import { createRoot } from "react-dom/client"; // <-- new API
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import './i18n';
import './style.scss';
import AnalyticsScript from "./AnalyticsScript";


const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <Suspense fallback={<div>Loading...</div>}>
      <App />
       {window.location.origin.includes("localhost") &&  <AnalyticsScript />}
    </Suspense>
  );
}

// Optional: service worker
serviceWorker.unregister();
